"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var luxon_1 = require("luxon");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var kaleidoscope_4 = require("@qwilr/kaleidoscope");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var StringManipulater_1 = require("Utils/StringManipulater");
var DisplayedTags_1 = __importDefault(require("./DisplayedTags/DisplayedTags"));
var HoverStateUtils_1 = require("./HoverStateUtils");
var DashboardSharePopoverButton_1 = require("./DashboardSharePopoverButton");
var AutoLinkExpiryController_1 = require("Project/SharePopover/AutoLinkExpiry/AutoLinkExpiryController");
var GetProjectNameWithDefault_1 = require("@CommonFrontendBackend/Utils/GetProjectNameWithDefault");
var PageEngagementDashboardPopover_1 = require("./PageEngagementDashboardPopover");
exports.BASE_CLASS_NAME = "project-list-item";
var ProjectListItem = (function (_super) {
    __extends(ProjectListItem, _super);
    function ProjectListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.isHovered = false;
        _this.renderPrimaryButton = function () {
            if (_this.projectStore.isAccepted) {
                return (react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary, onClick: _this.handleShowAuditTrail }, "Audit trail"));
            }
            return (react_1.default.createElement(DashboardSharePopoverButton_1.DashboardSharePopoverButton, { projectStore: _this.props.projectStore, isOpen: _this.isSharePopoverOpen, onChange: _this.onSharePopoverChange }));
        };
        _this.onPreviewClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.stopPropagation();
                        if (!!this.projectStore.linkStore.collaboratorHash) return [3, 2];
                        return [4, this.projectStore.getCollaboratorPageUrlWithGeneration({ source: TelemetryEnums_1.TelemetrySource.Dashboard })];
                    case 1:
                        url = _a.sent();
                        window.open(url);
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        _this.handlePreviewInActionMenuClick = function () {
            _this.dashboardController.preview(_this.projectStore);
        };
        _this.clone = function () {
            return _this.props.onCloneClick();
        };
        _this.createBlueprint = function () {
            _this.dashboardController.createBlueprint(_this.projectStore);
        };
        _this.createPDF = function () {
            _this.dashboardController.createPDF(_this.projectStore);
        };
        _this.openTagger = function (event) {
            event.stopPropagation();
            _this.dashboardController.openTagger(_this.projectStore);
        };
        _this.changeOwner = function () {
            _this.dashboardController.changeOwner(_this.projectStore);
        };
        _this.enableProject = function () {
            _this.projectStore.setStatus({ status: Types_1.ProjectStatus.Draft });
        };
        _this.toggleArchived = function () {
            _this.props.onArchiveClick();
        };
        _this.renderActionMenu = function () {
            var archiveText = _this.projectStore.isArchived ? "Unarchive" : "Archive";
            var disableActions = !_this.dashboardController.canEditProject(_this.projectStore);
            var isAccepted = _this.projectCardStatus === ProjectCardStatus.Accepted;
            var shouldDisableClone = _this.projectStore.isCrmTemplate && !_this.props.isAdmin;
            var actionMenuItems = [
                {
                    text: "Make a clone",
                    onClick: _this.clone,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyDesktop,
                    disabled: shouldDisableClone,
                },
                {
                    text: "Create blueprint",
                    onClick: _this.createBlueprint,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyDesktop,
                },
                {
                    text: "Create PDF",
                    onClick: _this.createPDF,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyDesktop,
                },
                {
                    text: "Share",
                    onClick: _this.handleShareClick,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyMobile,
                },
                {
                    text: "Preview",
                    onClick: _this.handlePreviewInActionMenuClick,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyMobile,
                },
                {
                    text: _this.projectStore.isStarred ? "Unstar" : "Star",
                    onClick: _this.handleStarClick,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyMobile,
                },
                {
                    text: "Tag this page",
                    onClick: _this.openTagger,
                    disabled: disableActions,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyDesktop,
                },
                {
                    text: "Change owner",
                    onClick: _this.changeOwner,
                    disabled: disableActions,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyDesktop,
                },
                {
                    text: archiveText,
                    onClick: _this.toggleArchived,
                    disabled: disableActions,
                },
            ];
            if (_this.projectStore.status === Types_1.ProjectStatus.Disabled) {
                actionMenuItems.push({
                    text: "Enable",
                    onClick: _this.enableProject,
                    disabled: disableActions,
                });
            }
            if (_this.projectCardStatus === ProjectCardStatus.Blueprint) {
                actionMenuItems.splice(1, 3, {
                    text: "View children",
                    onClick: _this.handleViewChildrenClick,
                    responsiveConfig: ActionMenuItemResponsiveConfig.OnlyMobile,
                });
            }
            return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: "".concat(exports.BASE_CLASS_NAME, "__action-menu"), isOpen: _this.isActionMenuOpen, onClose: function () { return _this.dashboardViewStore.closeProjectActionMenu(); }, button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null), type: kaleidoscope_1.ButtonType.Tertiary, onClick: _this.onOptionsClick, size: kaleidoscope_1.ButtonSize.Small, tooltip: {
                        content: "More actions",
                    } }) },
                actionMenuItems.map(function (item) {
                    var _a;
                    return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: item.text, className: (0, classnames_1.default)((_a = {},
                            _a["".concat(exports.BASE_CLASS_NAME, "__action-menu-item--").concat(item.responsiveConfig)] = item.responsiveConfig,
                            _a)), onClick: function (event) {
                            event.stopPropagation();
                            item.onClick(event);
                        }, disabled: item.disabled }, item.text));
                }),
                react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null),
                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { destructive: true, onClick: function (event) {
                        event.stopPropagation();
                        _this.props.onDeleteClick(event);
                    }, disabled: disableActions || isAccepted }, "Delete")));
        };
        _this.stopPropagation = function (event) { return event.stopPropagation(); };
        _this.onCheckboxClick = function (_checked, _id, event) {
            event && event.stopPropagation();
            return _this.props.onCheckboxClick && _this.props.onCheckboxClick(event);
        };
        _this.handleAnalyticsClick = function (event, eventOrigin) {
            event && event.stopPropagation();
            _this.dashboardController.openProjectAnalytics(_this.projectStore, eventOrigin);
        };
        _this.handleEngagementPopoverAnalyticsClick = function (event) {
            _this.handleAnalyticsClick(event, "page_engagement_popover");
        };
        _this.handleStarClick = function (event) {
            event && event.stopPropagation();
            if (_this.dashboardController.canEditProject(_this.projectStore)) {
                _this.projectStore.toggleStarred();
            }
        };
        _this.handleShareClick = function (event) {
            event && event.stopPropagation();
            _this.props.onShareClick();
        };
        _this.handleShowAuditTrail = function (event) {
            event && event.stopPropagation();
            _this.props.dashboardController.showAuditTrail(_this.projectStore);
        };
        _this.handleViewChildrenClick = function (event) {
            event && event.stopPropagation();
            _this.props.onViewChildren();
        };
        _this.onOptionsClick = function (event) {
            event.stopPropagation();
            if (_this.isActionMenuOpen) {
                _this.dashboardViewStore.closeProjectActionMenu();
            }
            else {
                _this.dashboardViewStore.setOpenProjectActionMenuId(_this.projectStore._id);
            }
        };
        _this.onSharePopoverChange = function (isOpening) {
            if (isOpening && !_this.isSharePopoverOpen) {
                _this.dashboardViewStore.setOpenSharePopoverId(_this.projectStore._id);
            }
            else if (!isOpening && _this.isSharePopoverOpen) {
                _this.dashboardViewStore.closeAllMenus();
            }
        };
        _this.onEngagementPopoverChange = function (isOpening) {
            if (isOpening && !_this.isEngagementPopoverOpen) {
                _this.dashboardViewStore.setOpenEngagementPopoverId(_this.projectStore._id);
            }
            else if (!isOpening && _this.isEngagementPopoverOpen) {
                _this.dashboardViewStore.closeAllMenus();
            }
        };
        _this.projectStore = props.projectStore;
        _this.dashboardController = props.dashboardController;
        _this.dashboardViewStore = props.dashboardViewStore;
        return _this;
    }
    ProjectListItem.prototype.render = function () {
        var _a;
        var _b = this.props, onDragStart = _b.onDragStart, height = _b.height, marginBottom = _b.marginBottom, showMinimalActions = _b.showMinimalActions;
        return (react_1.default.createElement("div", { key: this.projectStore._id, className: (0, classnames_1.default)(exports.BASE_CLASS_NAME, (_a = {},
                _a["".concat(exports.BASE_CLASS_NAME, "--selected")] = this.props.isSelected,
                _a["".concat(exports.BASE_CLASS_NAME, "--selecting")] = this.props.isSelecting,
                _a["".concat(exports.BASE_CLASS_NAME, "--active")] = this.isActive,
                _a["".concat(exports.BASE_CLASS_NAME, "--minimal")] = showMinimalActions,
                _a["".concat(exports.BASE_CLASS_NAME, "--apply-animation")] = this.props.applySelectionAnimation,
                _a)), style: {
                height: height,
                marginBottom: marginBottom,
            }, onMouseDown: this.stopPropagation, onClick: this.props.onClick, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, draggable: !!onDragStart, onDragStart: onDragStart, "data-synthetics-selector": "project-list-item", "data-testid": "project-list-item" },
            react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__left-actions") },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(kaleidoscope_4.Checkbox, { labelHidden: true, className: "".concat(exports.BASE_CLASS_NAME, "__checkbox"), id: this.projectStore._id, label: this.projectStore.name, checked: this.props.isSelected, size: "m", onChange: this.onCheckboxClick })),
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__main-text") },
                    react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__name") }, (0, GetProjectNameWithDefault_1.getProjectNameWithDefault)(this.projectStore.name)),
                    react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__tags-container") },
                        react_1.default.createElement("div", { onClick: this.openTagger, className: "".concat(exports.BASE_CLASS_NAME, "__tags") },
                            react_1.default.createElement(DisplayedTags_1.default, { tags: this.projectStore.tags })),
                        this.projectStore.lastEditedAt && this.isActive && (react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs" },
                            "Last Edited: ",
                            this.projectStore.lastEditedAt))))),
            this.renderRightActions()));
    };
    ProjectListItem.prototype.renderRightActions = function () {
        var _a;
        var canEditProject = this.dashboardController.canEditProject(this.projectStore);
        var _b = this.projectStore, isStarred = _b.isStarred, engagement = _b.engagement, lastViewedAt = _b.lastViewedAt, _id = _b._id, status = _b.status, isBlueprint = _b.isBlueprint, isTemplate = _b.isTemplate;
        return (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__right-actions") },
            this.projectStatus,
            this.projectCardStatus === ProjectCardStatus.Blueprint ? (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__view-children") },
                react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary, onClick: this.handleViewChildrenClick }, "View children"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_3.Tooltip, { size: kaleidoscope_3.TooltipSize.Small, content: this.projectStore.totalLinkViews ? "Last viewed: ".concat(lastViewedAt) : "No Views" },
                    react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__views") }, this.views)),
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__primary-button") }, this.renderPrimaryButton()))),
            this.renderPreviewButton(),
            react_1.default.createElement("div", { className: "pinned-actions" },
                react_1.default.createElement(kaleidoscope_1.IconButton, { className: (0, classnames_1.default)("".concat(exports.BASE_CLASS_NAME, "__star"), (_a = {},
                        _a["".concat(exports.BASE_CLASS_NAME, "__star--is-disabled")] = !canEditProject,
                        _a["".concat(exports.BASE_CLASS_NAME, "__star--is-starred")] = isStarred,
                        _a)), icon: this.starIcon, onClick: this.handleStarClick, size: kaleidoscope_1.ButtonSize.Small, tooltip: {
                        content: isStarred ? "Unstar" : "Star",
                    } }),
                !isBlueprint && !isTemplate && (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__engagement-level") },
                    react_1.default.createElement(PageEngagementDashboardPopover_1.PageEngagementDashboardPopover, { projectStore: this.projectStore, onAnalyticsClick: this.handleEngagementPopoverAnalyticsClick, canEditProject: canEditProject, isAdmin: this.props.isAdmin, isOpen: this.isEngagementPopoverOpen, onPopoverChange: this.onEngagementPopoverChange }))),
                this.projectCardStatus !== ProjectCardStatus.Blueprint && (react_1.default.createElement(kaleidoscope_1.IconButton, { className: "".concat(exports.BASE_CLASS_NAME, "__analytics"), icon: react_1.default.createElement(icons_1.Analytics, null), onClick: this.handleAnalyticsClick, size: kaleidoscope_1.ButtonSize.Small, tooltip: {
                        content: "Analytics",
                    } })),
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__options") }, this.renderActionMenu()))));
    };
    ProjectListItem.prototype.renderPreviewButton = function () {
        var _this = this;
        var actionName = "Preview";
        var href = !!this.projectStore.linkStore.collaboratorHash
            ? function () { return _this.projectStore.getCollaboratorPageUrl({ source: TelemetryEnums_1.TelemetrySource.Dashboard }); }
            : undefined;
        return (react_1.default.createElement(kaleidoscope_1.IconButton, { buttonState: kaleidoscope_2.ButtonState.Idle, className: "".concat(exports.BASE_CLASS_NAME, "__preview"), icon: react_1.default.createElement(icons_1.Preview, null), "aria-label": actionName, href: href, onClick: this.onPreviewClick, size: kaleidoscope_1.ButtonSize.Small, tooltip: {
                content: actionName,
            } }));
    };
    Object.defineProperty(ProjectListItem.prototype, "isActive", {
        get: function () {
            return this.isHovered || this.isActionMenuOpen || this.isSharePopoverOpen || this.isEngagementPopoverOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListItem.prototype, "isActionMenuOpen", {
        get: function () {
            return this.dashboardViewStore.openProjectActionMenuId === this.projectStore._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListItem.prototype, "isSharePopoverOpen", {
        get: function () {
            return this.dashboardViewStore.openSharePopoverId === this.projectStore._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListItem.prototype, "isEngagementPopoverOpen", {
        get: function () {
            return this.dashboardViewStore.openEngagementPopoverId === this.projectStore._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListItem.prototype, "starIcon", {
        get: function () {
            if (this.projectStore.isStarred) {
                return react_1.default.createElement(icons_1.StarFilled, null);
            }
            else {
                return react_1.default.createElement(icons_1.Star, null);
            }
        },
        enumerable: false,
        configurable: true
    });
    ProjectListItem.prototype.onMouseEnter = function () {
        if (this.props.allowHoverState && (0, HoverStateUtils_1.viewportWidthAllowsHover)()) {
            this.isHovered = true;
        }
    };
    ProjectListItem.prototype.onMouseLeave = function () {
        this.isHovered = false;
    };
    Object.defineProperty(ProjectListItem.prototype, "views", {
        get: function () {
            return (0, StringManipulater_1.pluralise)(this.projectStore.totalLinkViews || 0, "view", undefined, "no");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListItem.prototype, "renderStatusIcon", {
        get: function () {
            switch (this.projectCardStatus) {
                case ProjectCardStatus.Accepted:
                    return react_1.default.createElement(icons_1.Tick, null);
                case ProjectCardStatus.Declined: {
                    if (this.projectStore.subStatus === Types_1.ProjectSubStatus.DeclinedExpired) {
                        return react_1.default.createElement(icons_1.Clock, null);
                    }
                    return react_1.default.createElement(icons_1.Close, null);
                }
                case ProjectCardStatus.TimeLimit:
                    return react_1.default.createElement(icons_1.Clock, null);
                case ProjectCardStatus.ViewLimit:
                    return react_1.default.createElement(icons_1.Preview, null);
                default:
                    return react_1.default.createElement(icons_1.ListMarkerCircle, null);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListItem.prototype, "projectCardStatus", {
        get: function () {
            var _a = this.projectStore, status = _a.status, isWithinTimeLimit = _a.isWithinTimeLimit, isWithinViewLimit = _a.isWithinViewLimit, isBlueprint = _a.isBlueprint, hasAcceptEnabled = _a.hasAcceptEnabled;
            if (status === Types_1.ProjectStatus.Accepted) {
                return ProjectCardStatus.Accepted;
            }
            else if (status === Types_1.ProjectStatus.Declined) {
                return ProjectCardStatus.Declined;
            }
            else if (status === Types_1.ProjectStatus.Disabled) {
                return ProjectCardStatus.Disabled;
            }
            else if (isBlueprint) {
                return ProjectCardStatus.Blueprint;
            }
            else if (!isWithinTimeLimit) {
                return ProjectCardStatus.TimeLimit;
            }
            else if (!isWithinViewLimit) {
                return ProjectCardStatus.ViewLimit;
            }
            else if (status === Types_1.ProjectStatus.Draft) {
                return ProjectCardStatus.Draft;
            }
            else if (hasAcceptEnabled) {
                return ProjectCardStatus.Pending;
            }
            else {
                return ProjectCardStatus.Live;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListItem.prototype, "projectStatus", {
        get: function () {
            var statusText = getStatusText(this.projectCardStatus, this.projectStore.partialAcceptanceData);
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(exports.BASE_CLASS_NAME, "__status"), "".concat(exports.BASE_CLASS_NAME, "__status--").concat((0, lodash_1.kebabCase)(this.projectCardStatus))) },
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__status-icon-wrapper") },
                    react_1.default.createElement(ProjectStatusIcon, { statusIcon: this.renderStatusIcon, projectCardStatus: this.projectCardStatus, projectStore: this.projectStore })),
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__status-text") }, statusText)));
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ProjectListItem.prototype, "isHovered", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListItem.prototype, "enableProject", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "isActive", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "isActionMenuOpen", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "isSharePopoverOpen", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "isEngagementPopoverOpen", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof react_1.ReactElement !== "undefined" && react_1.ReactElement) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "starIcon", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectListItem.prototype, "onMouseEnter", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectListItem.prototype, "onMouseLeave", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "views", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListItem.prototype, "onCheckboxClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListItem.prototype, "onOptionsClick", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof JSX !== "undefined" && JSX.Element) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "renderStatusIcon", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "projectCardStatus", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof JSX !== "undefined" && JSX.Element) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListItem.prototype, "projectStatus", null);
    ProjectListItem = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ProjectListItem);
    return ProjectListItem;
}(react_1.default.Component));
exports.default = ProjectListItem;
var getStatusText = function (projectCardStatus, partialAcceptanceData) {
    if (projectCardStatus === ProjectCardStatus.Pending) {
        if (partialAcceptanceData) {
            var accepters = partialAcceptanceData.accepters, totalNumAccepters = partialAcceptanceData.totalNumAccepters;
            if (accepters && accepters.length > 0 && totalNumAccepters > 1) {
                return "".concat(accepters.length, " / ").concat(totalNumAccepters, " accepted");
            }
        }
    }
    return projectCardStatus || "draft";
};
function ProjectStatusIcon(props) {
    var wrapInTooltip = (0, react_1.useCallback)(function (content) {
        return (react_1.default.createElement(kaleidoscope_3.Tooltip, { size: kaleidoscope_3.TooltipSize.Small, content: content }, props.statusIcon));
    }, [props.statusIcon]);
    if (props.projectCardStatus === ProjectCardStatus.TimeLimit) {
        return wrapInTooltip("Time limit exceeded");
    }
    else if (props.projectCardStatus === ProjectCardStatus.ViewLimit) {
        return wrapInTooltip("View limit exceeded");
    }
    else if (props.projectCardStatus === ProjectCardStatus.Declined &&
        props.projectStore.subStatus === Types_1.ProjectSubStatus.DeclinedExpired) {
        var autoLinkExpiryController = new AutoLinkExpiryController_1.AutoLinkExpiryController(props.projectStore);
        var expiryDateTime = luxon_1.DateTime.fromJSDate(autoLinkExpiryController.expiryDate);
        return wrapInTooltip("Expired ".concat(expiryDateTime.toLocaleString(luxon_1.DateTime.DATE_FULL)));
    }
    return props.statusIcon;
}
var ProjectCardStatus;
(function (ProjectCardStatus) {
    ProjectCardStatus["Live"] = "live";
    ProjectCardStatus["Accepted"] = "accepted";
    ProjectCardStatus["Declined"] = "declined";
    ProjectCardStatus["Draft"] = "draft";
    ProjectCardStatus["TimeLimit"] = "time limit";
    ProjectCardStatus["ViewLimit"] = "view limit";
    ProjectCardStatus["Disabled"] = "disabled";
    ProjectCardStatus["Blueprint"] = "blueprint";
    ProjectCardStatus["Pending"] = "pending";
})(ProjectCardStatus || (ProjectCardStatus = {}));
var ActionMenuItemResponsiveConfig;
(function (ActionMenuItemResponsiveConfig) {
    ActionMenuItemResponsiveConfig["OnlyMobile"] = "only-mobile";
    ActionMenuItemResponsiveConfig["OnlyDesktop"] = "only-desktop";
})(ActionMenuItemResponsiveConfig || (ActionMenuItemResponsiveConfig = {}));
